"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _modalDecorator = _interopRequireDefault(require("../../hocs/modalDecorator"));
var _modalActions = require("../../redux/actions/modalActions");
var _Modal = _interopRequireDefault(require("../common/Modal/Modal"));
var _MarginTransferAssetsFormContainer = _interopRequireDefault(require("./MarginTransferAssetsFormContainer"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var MarginTransferAssetsModalComponent = function MarginTransferAssetsModalComponent(_ref) {
  var close = _ref.close,
    isOpen = _ref.isOpen,
    productId = _ref.productId;
  var _useTranslation = (0, _reactI18next.useTranslation)('margin'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    isOpen: isOpen,
    title: t('Transfer Assets'),
    close: close
  }, /*#__PURE__*/_react["default"].createElement(_MarginTransferAssetsFormContainer["default"], {
    defaultProductId: productId,
    closeModal: close
  }));
};
MarginTransferAssetsModalComponent.propTypes = {
  isOpen: _propTypes["default"].bool,
  close: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = (0, _modalDecorator["default"])({
  name: _modalActions.MODAL_TYPES.MARGIN_TRANSFER_ASSETS
})(MarginTransferAssetsModalComponent);